<template lang="pug">
.panel.panel-image
  .panel-header.columns.flex-centered
    .column.text-ellipsis.text-small {{ file.name }}
    .column.col-auto
      button.btn-sm.btn.btn-error.tooltip.tooltip-left(data-tooltip="Remover" @click="$emit('remove', index)")
        i.fa.fa-trash
  .panel-body.pb-1(:class="convertingBlob && 'loading'")
    img.s-rounded.img-responsive.img-content(v-if="base64" :src="base64")
</template>

<script>

async function convertBlobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export default {
  props: ['file', 'index'],
  data() {
    return {
      convertingBlob: false,
      base64: ''
    }
  },
  async created () {
    try {
      this.convertingBlob = true
      this.base64 = await convertBlobToBase64(this.file)
    } finally {
      this.convertingBlob = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.img-content
  margin: 0 auto
  height: 100%
  width: auto
</style>
